import { APIRequest } from '@/app/services/APIRequest';
import store from '@/app/vuex/store';

export default {
  data: () => ({
    textField: null,
    itemsTypeProduct: [],
    selectedCategory: null
  }),
  mounted(){
    this.getCategory();
    const queryString = this.$route.query;
    if (queryString.name) this.textField = queryString.name;
    if (queryString.category) this.selectedCategory = queryString.category;
  },
  methods: {
    getCategory(){
      APIRequest({
        method: 'GET',
        url: '/category/list-sub-category',
        auth: true
      }).then(response => {
        store.dispatch('loading/setLoading', false);
        if (response && response.data.code === 10 && response.data.result){
          this.itemsTypeProduct = response.data.result;
        }
      }).catch(error => {
        store.dispatch('loading/setLoading', false);
        console.log(error);
      });
    },

    handleSearch(e){
      e.preventDefault();
      this.$router.push({ name: 'Product', query: { name: this.textField, category: this.selectedCategory } });
    },
    handleResetData(){
      this.textField = null;
      this.dates = [];
      this.$router.push({ name: 'Product' });
    }
  }
};
